import React from 'react';
import { useTranslation } from 'react-i18next';
import './NotificationBell.css';
import NotificationItem from './NotificationItem';

interface Notification {
  id: number;
  type: string;
  title: string;
  message: string;
  icon: string;
  data: any;
  read: boolean;
  created_at: string;
}

interface NotificationDropdownProps {
  notifications: Notification[];
  loading: boolean;
  unreadCount: number;
  onMarkAsRead: (id: number) => void;
  onMarkAllAsRead: () => void;
  onDelete: (id: number) => void;
  onClose: () => void;
}

const NotificationDropdown: React.FC<NotificationDropdownProps> = ({
  notifications,
  loading,
  unreadCount,
  onMarkAsRead,
  onMarkAllAsRead,
  onDelete,
  onClose
}) => {
  const { t } = useTranslation();

  return (
    <div className="notification-dropdown">
      {/* Заголовок */}
      <div className="notification-header">
        <div className="notification-title">
          <span className="notification-icon">🔔</span>
          <span>{t('notifications.title')}</span>
          {unreadCount > 0 && (
            <span className="unread-badge">{unreadCount}</span>
          )}
        </div>
        {unreadCount > 0 && (
          <button
            className="mark-all-read-btn"
            onClick={onMarkAllAsRead}
            title={t('notifications.markAllRead')}
          >
            <span>✓</span> {t('notifications.allRead')}
          </button>
        )}
      </div>

      {/* Список уведомлений */}
      <div className="notification-list">
        {loading ? (
          <div className="notification-loading">
            <div className="loading-spinner"></div>
            <p>{t('notifications.loading')}</p>
          </div>
        ) : notifications.length === 0 ? (
          <div className="notification-empty">
            <div className="empty-icon">📭</div>
            <p>{t('notifications.empty')}</p>
            <span>{t('notifications.emptyHint')}</span>
          </div>
        ) : (
          notifications.map((notification) => (
            <NotificationItem
              key={notification.id}
              notification={notification}
              onMarkAsRead={onMarkAsRead}
              onDelete={onDelete}
            />
          ))
        )}
      </div>

      {/* Футер */}
      {notifications.length > 0 && (
        <div className="notification-footer">
          <span className="notification-count">
            {t('notifications.shown', { count: notifications.length })}
          </span>
        </div>
      )}
    </div>
  );
};

export default NotificationDropdown;
